export class ValidatorsHelper {
  public static NAME_REGEX = /^[a-zA-Z0-9\-_]+$/;
}
